<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { useContextMenu } from '@/composables/useContextMenu'

const { state, closeMenu } = useContextMenu()

function onItemClick(fn?: () => void): void {
  closeMenu()
  fn?.()
}
function onDocMousedown(e: MouseEvent): void {
  const el = document.getElementById('tds-context-menu')
  if (el && !el.contains(e.target as Node)) closeMenu()
}
function onKeydown(e: KeyboardEvent): void {
  if (e.key === 'Escape') closeMenu()
}
onMounted(() => {
  document.addEventListener('mousedown', onDocMousedown)
  document.addEventListener('keydown', onKeydown)
})
onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onDocMousedown)
  document.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <Teleport to="body">
    <div
      v-if="state.visible"
      id="tds-context-menu"
      class="menu js-pop"
      :style="{ top: `${state.y}px`, left: `${state.x}px` }"
    >
      <template v-for="(it, i) in state.items" :key="i">
        <div v-if="it === '-'" class="sep" />
        <button v-else type="button" :class="{ danger: it.danger }" @click="onItemClick(it.fn)">
          {{ it.label }}
        </button>
      </template>
    </div>
  </Teleport>
</template>
